import React, {memo, useMemo} from 'react';
import {View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {useLocale} from '@redlink/assets/locale';
import {RadioButtonGroup} from '@redlink/components/muscles';
import {isMobile} from 'react-device-detect';
import {Space} from "../atoms";

export const JobStatus = memo(({onChange, currentJobStatus}) => {
    const {styles} = useStyle();
    const {dictionary} = useLocale();

    const jobStatusOptions = useMemo(
        () => [
            {title: dictionary.working, value: 'working'},
            {title: dictionary.openToWork, value: 'openToWork'},
        ],
        []
    );
    return (
        <View
            style={[
                styles.jobStatusContainer,
                isMobile && styles.jobStatusContainerMobile,
            ]}
        >
            {jobStatusOptions.map((item, index) => {
                const isSelected = item.value === currentJobStatus;
                return (
                    <>
                        <RadioButtonGroup
                            key={index}
                            {...{item, isSelected}}
                            onSelectItem={() => onChange(item.value, index + 1)}
                            withAction={false}
                            noContainer
                            iconSize={25}
                        />
                        <Space/>
                    </>
                );
            })}
        </View>
    );
});

const useStyle = createUseStyle(() => ({
    jobStatusContainer: {
        flexDirection: 'row',
        width: '70%',
        alignItems: 'center'
    },
    jobStatusContainerMobile: {
        width: '100%',
    },
}));
